import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { KEYS } from "../../../../Config/Keys";
import moment from "moment";
import { fallbackprofile, loadimage } from "../../../../common/Utils";

const { Meta } = Card;
const TeamsCard = ({ data }) => {
  const [loading, setloading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadimage(KEYS.API + "/" + data?.profilepic, setloading);
  }, [data?.profilepic]);
  return (
    <Fragment>
      <Col
        className="pomemberShadow TPcard"
        xxl={6}
        xl={8}
        lg={{ span: 12 }}
        md={{ span: 12 }}
        sm={24}
        xs={24}
        onClick={() => {
          if (!loading) {
            localStorage.setItem("team", data?._id);
            navigate(`/player/team/${data?._id}/timeline`);
          }
        }}>
        <Card>
          <Skeleton className="cardskelton" loading={loading} avatar active>
            <Meta
              style={{
                display: "grid",
                placeContent: "center",
                background: ""
              }}
              avatar={
                <img
                  src={KEYS.API + "/" + data?.profilepic}
                  onErrorCapture={(e) => (e.currentTarget.src = fallbackprofile)}
                  alt=""
                  style={{
                    width: 90,
                    height: 90,
                    objectFit: "cover",
                    marginBottom: "20px",
                    borderRadius: "50%"
                  }}
                />
              }
            />
            <div className="additional">
              <h4 style={{ fontWeight: "550", marginBottom: ".4rem", fontSize: "17px" }}>
                {String(data?.name).length >= 25
                  ? data?.name.substring(0, 25) + " ..."
                  : data?.name}
              </h4>
              <p className="timelineslotscolor" style={{ margin: "5px auto", fontWeight: "500" }}>
                {data?.location}
              </p>
              <small className="timelineredtext" style={{ margin: ".4rem auto 0 auto" }}>
                {"Created " + moment(data?.createdAt).fromNow() + " at " + data?.location}
              </small>
            </div>
          </Skeleton>
        </Card>
      </Col>
    </Fragment>
  );
};

export default TeamsCard;
